<template>
  <span :class="[type, { disabled: isDisabled }]" :aria-disabled="isDisabled" :tabindex="isDisabled ? -1 : 0">
    <slot></slot>
  </span>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  type: {
    type: String,
    default: 'primary'
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const isDisabled = ref(props.disabled);
</script>

<style scoped>
span {
  cursor: pointer;
  transition: color 0.3s, filter 0.3s;
}

/* 普通状态下的样式 */
.primary {
  color: var(--el-color-primary);
}
.primary:hover {
  filter: brightness(85%); /* 渐暗 */
}

.success {
  color: var(--el-color-success);
}
.success:hover {
  filter: brightness(85%);
}

.danger {
  color: var(--el-color-danger);
}
.danger:hover {
  filter: brightness(85%);
}

.info {
  color: var(--el-color-info);
}
.info:hover {
  filter: brightness(85%);
}

.default {
  color: var(--el-color-primary);
}
.default:hover {
  filter: brightness(85%);
}

/* 禁用状态的样式 */
.disabled {
  cursor: not-allowed !important; /* 禁用时的鼠标指针 */
  opacity: 0.6; /* 可以加一点透明度来显示禁用状态 */
}

.disabled:hover {
  filter: none; /* 禁用时不允许有鼠标悬停效果 */
}

span[aria-disabled="true"] {
  pointer-events: none; /* 禁止点击 */
}
</style>
